<template>
    <div :class="boxClass.box" class="no-margin">
        <div :class="boxClass.boxHeader">
            <div class="box-title">{{ charity.name }}</div>
        </div>
        <div :class="boxClass.boxBody">
            <div class="row">
                <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-form-label text-center text-right-sm"
                     v-if="charity.image_public_path">
                    <img
                        :alt="charity.name"
                        class='img-fluid img-responsive'
                        :src="charity.image_public_path"
                        style='max-height: 250px;'
                        v-if="charity.image_public_path"
                    >
                </div>
                <div
                    class="col-xs-12"
                    :class="{
                        'col-sm-5 col-md-5 col-lg-5': charity.image_public_path,
                        'col-sm-6 col-md-6 col-lg-6': !charity.image_public_path,
                    }">

                    <div v-html="charity.description"></div>
                </div>

                <div
                    class="col-xs-12"
                    :class="{
                        'col-sm-4 col-md-4 col-lg-4': charity.image_public_path,
                        'col-sm-6 col-md-6 col-lg-6': !charity.image_public_path,
                    }"
                >
                    <donation-amount
                        :charity="charity"
                        :value="donation.amount"
                        @input="updateDonationAmount"
                    ></donation-amount>
                </div>
            </div>
            <!-- If gift aid can be selected -->
            <div class="row margin-top" v-if="allowGiftAid && donation.amount > 0">
                <div class="col-md-12">
                    <p>I am a UK tax payer and this donation is gift aid eligible</p>
                    <b-form-radio-group
                        stacked
                        v-model="donation.gift_aid"
                        :options="[
                            {
                              text: 'Yes',
                              value: true,
                            },
                            {
                              text: 'No',
                              value: false,
                            }
                        ]"
                        data-vv-as="field"
                        :disabled="disabled"
                        :name="`gift_aid_${charity.name}`"
                        v-validate="'required'"
                        :state="false"
                        @input="updateDonationGiftAid"
                    />
                    <p v-if="donation.gift_aid" style="font-style: italic;">By clicking yes, you agree that you are
                        a
                        UK taxpayer
                        and understand that if you pay less Income Tax and/or Capital Gains Tax in the current tax
                        year than the
                        amount of Gift Aid claimed on all your donations it is your responsibility to pay any
                        difference. If you gift aid your donation, you are also consenting to the details being used
                        by the charity to claim gift aid on your behalf.</p>
                </div>
            </div>
            <div class="row" v-if="donation.gift_aid">
                <div class="col-md-12">
                    <donation-address
                        :country="donation.country"
                        :county="donation.county"
                        :email="donation.email"
                        :fields="['country', 'county', 'email', 'first_name', 'last_name', 'line_1', 'post_code']"
                        :first_name="donation.first_name"
                        :last_name="donation.last_name"
                        :line_1="donation.line_1"
                        :line_2="donation.line_2"
                        :post_code="donation.post_code"
                        :town="donation.town"
                        @updateAddress="updateAddress"
                    ></donation-address>
                </div>
            </div>
            <div class="row" v-if="charity.additional_questions !== null && charity.additional_questions.length && donation.amount > 0">
                <div class="col-md-12">
                    <form-renderer
                        :form-fields="charity.additional_questions"
                        @input="additional_answers => Object.assign(donation, {additional_answers})"
                        :value="donation.additional_answers"
                    ></form-renderer>
                </div>
            </div>
        </div>
        <div :class="boxClass.boxFooter" v-if="donation.amount > 0 && donation.fundraising_page_id">
            <label for="donation_message" class="control-label">Your Message</label>
            <textarea
                v-model="donation.fundraising_message"
                class="form-control"
                name="donation_message"
                id="donation_message"
                rows="5"
            ></textarea>
        </div>
    </div>
</template>

<script>
import DonationAmount from "./Amount.vue";
import DonationAddress from "./Address.vue";
import FormRenderer from "../../Utility/Forms/FormRenderer/FirstIteration/FormRenderer.vue";

export default {
    components: {
        DonationAddress,
        DonationAmount,
        FormRenderer,
    },

    props: {
        singleAddress: {
            type: Boolean,
            required: false,
            default: false,
        },
        charity: {
            type: Object,
            required: true,
        },
        donation: {
            type: Object,
            required: false,
            default: () => ({
                additional_answers: {},
                amount: null,
                country: null,
                county: null,
                email: null,
                first_name: null,
                fundraising_message: null,
                fundraising_page_id: null,
                gift_aid: null,
                last_name: null,
                line_1: null,
                line_2: null,
                post_code: null,
                town: null,
            }),
        },
        theme: {
            type: String,
            default: 'bs4',
            required: false,
        },
    },

    computed: {
        allowGiftAid() {
            return !this.singleAddress && this.charity.gift_aid;
        },
        boxClass() {
            if (this.theme == 'bs3') {
                return {
                    box: 'panel panel-default',
                    boxHeader: 'panel-heading',
                    boxBody: 'panel-body',
                    boxFooter: 'panel-footer',
                    boxTools: 'box-tools pull-right',
                    padding: ''
                }
            } else if (this.theme == 'evt') {
                return {
                    box: 'box box-default',
                    boxHeader: 'box-header with-border',
                    boxBody: 'box-body',
                    boxFooter: 'box-footer',
                    boxTools: 'box-tools pull-right',
                    padding: ''
                }
            } else {
                return {
                    box: 'card card-default',
                    boxHeader: 'card-header d-flex',
                    boxBody: 'card-body',
                    boxFooter: 'card-footer',
                    boxTools: 'box-tools ml-auto',
                    padding: 'px-0 py-0'
                }
            }
        },
    },

    methods: {
        removeDonation(charityId) {
            this.$emit(`removeDonation`, charityId);
        },
        updateAddress(newVals) {
            this.updateDonation(newVals);
        },
        updateDonation(newVals) {
            this.$emit(`updateDonation`, {
                charityId: this.charity.id,
                donation: newVals,
            });
        },
        updateDonationAmount(amount) {
            if (amount === 0) {
                this.removeDonation(this.charity.id);
            } else {
                this.updateDonation({amount});
            }
        },
        updateDonationGiftAid(event) {
            let gift_aid = event.target.checked;
            this.updateDonation({gift_aid});
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Donations/Form/Default.vue